import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js'
import { mapState } from 'vuex'

export default {
  props: {
    content: { type: String, default: '' },
    path: { type: String, default: '' }
  },
  computed: {
    ...mapState(['language'])
  },
  render () {
    const { content, path, generateContainer } = this
    if (!content && !path) return

    // 优先解析 content prop 内容
    if (content) {
      return generateContainer(content)
    }

    return generateContainer(this.dynamicLoader())
  },
  methods: {
    dynamicLoader () {
      const { language, path } = this
      try {
        return require(`@/documents/${language}/${path}.md`).default
      } catch (error) {
        console.log(`Markdown 文档加载失败，位置：${path}`)
      }
      return ''
    },
    generateContainer (content) {
      const option = {
        html: true,
        xhtmlOut: true,
        breaks: true,
        highlight (str, lang) {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs
                .highlight(str, { language: lang })
                .value
            } catch (exception) {}
          }

          // use external default escaping
          return ''
        }
      }

      return this.$createElement('div', {
        class: 'markdown-body',
        domProps: {
          innerHTML: MarkdownIt(option).render(content)
        }
      })
    }
  }
}
